<div class="wrapper theme2">

    <div class="block-content">
        <div>
            <app-public-menu></app-public-menu>
            <div class="flex justify-content-center">
                <div class="container">
                    <div class="grid header">
                        <div class="col-12">
                            <p class="text-6xl">
                                Sobre Nosotros
                            </p>
                            <p class="text-1xl">
                                Easyrentestate, liderada por José María Balcells, sobresale en el sector inmobiliario por su enfoque transparente y seguro. La estrategia se basa en una selección detallada de propiedades y en fomentar la confianza.
                                Nos dedicamos a simplificar las inversiones inmobiliarias, asegurando la máxima transparencia. Nuestro modelo de negocio prioriza la relación cercana con el inversor y promueve una comunicación clara sobre riesgos y estrategias, garantizando que los inversores estén bien informados para tomar decisiones sólidas.
                                Nos comprometemos a ser un aliado fiable en el sector, brindando una experiencia de inversión íntegra, clara y transparente.
                            </p>

                        </div>
                    </div>

                    <div class="grid mb-2 mt-2">
                        <div class="col-12 md:col-6">
                            <div class="card">
                                <div class="card-header">
                                    <img class="cardImg" src="/assets/img/informacion.png">
                                    <h3 class="card-title">Información de la empresa</h3>
                                </div>
                                <div class="card-body">
                                    <p class="text-blk cardSubHeading">
                                        Fundada con la visión de José María Balcells, Easyrentestate surge como respuesta a la necesidad de un acceso más directo y sin complicaciones a la inversión inmobiliaria. Comprometidos con la claridad y el rendimiento, nos esforzamos por simplificar el proceso de inversión, manteniendo los más altos estándares de transparencia y responsabilidad.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="card">
                                <div class="card-header">
                                    <img class="cardImg" src="/assets/img/resumen.png">
                                    <h3 class="card-title">
                                        Resumen Ejecutivo</h3>
                                </div>
                                <div class="card-body">
                                    <p class="text-blk cardSubHeading">
                                        Easyrentestate, liderada por José María Balcells, se compromete a ofrecer un acceso seguro y transparente al mercado inmobiliario nacional. Nuestra diferenciación radica en la claridad con la que presentamos cada oportunidad de inversión y en el meticuloso proceso de selección de propiedades, enfocado en su potencial de valorización y estabilidad a largo plazo. Entendemos que la confianza es la piedra angular de cualquier relación de inversión, por lo que nos esforzamos en ser un socio confiable que ofrece rendimientos sólidos a través de una estrategia de inversión fundamentada y prudente.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="grid mb-2 mt-2">
                        <div class="col-12 md:col-6">
                            <div class="card">
                                <div class="card-header">
                                    <img class="cardImg" src="/assets/img/descripcion.png">
                                    <h3 class="card-title">
                                        Descripción del Proyecto
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <p class="text-blk cardSubHeading">
                                        Fundada con la visión de José María Balcells, Easyrentestate surge como respuesta a la necesidad de un acceso más directo y sin complicaciones a la inversión inmobiliaria. Comprometidos con la claridad y el rendimiento, nos esforzamos por simplificar el proceso de inversión, manteniendo los más altos estándares de transparencia y responsabilidad.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="card">
                                <div class="card-header">
                                    <img class="cardImg" src="/assets/img/objetivos.png">
                                    <h3 class="card-title">
                                        Objetivos y Visión
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <p class="text-blk cardSubHeading">
                                        Guiados por una visión de hacer la inversión inmobiliaria accesible y confiable, Easyrentestate aspira a ser un referente de confianza en el mercado nacional. José María Balcells y su equipo están comprometidos con una estrategia de crecimiento sostenible, basada en la confianza mutua y el éxito compartido con nuestros inversores.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="grid mb-2 mt-2">
                        <div class="col-12 md:col-6">
                            <div class="card">
                                <div class="card-header">
                                    <img class="cardImg" src="/assets/img/mercado.png">
                                    <h3 class="card-title">
                                        Mercado y Competencia
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <p class="text-blk cardSubHeading">
                                        Operamos en un mercado inmobiliario nacional vibrante y en constante evolución. A diferencia de otros actores del mercado, nuestra prioridad es la transparencia total con nuestros inversores, ofreciendo una perspectiva clara y realista de cada oportunidad de inversión, sin ocultar los riesgos y siempre buscando maximizar los beneficios.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 md:col-6">
                            <div class="card">
                                <div class="card-header">
                                    <img class="cardImg" src="/assets/img/estrategia.png">
                                    <h3 class="card-title">
                                        Estrategia y Modelo de Negocio
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <p class="text-blk cardSubHeading">
                                        Nuestro modelo se fundamenta en la cercanía con el inversor y en la selección rigurosa de propiedades. Nos enfocamos en inversiones que entendemos a fondo, comunicando de manera abierta y honesta con nuestros inversores sobre cada aspecto de la inversión, desde los riesgos potenciales hasta las estrategias de mitigación.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="grid mb-2 mt-2">
                        <div class="col-12 md:col-6">
                            <div class="card">
                                <div class="card-header">
                                    <img class="cardImg" src="/assets/img/estructura.png">
                                    <h3 class="card-title">
                                        Estructura Societaria y Equipo Directivo
                                    </h3>
                                </div>
                                <div class="card-body">
                                    <p class="text-blk cardSubHeading">
                                        Dirigida por José María Balcells, nuestra estructura corporativa está diseñada para facilitar decisiones ágiles y basadas en el conocimiento profundo del mercado nacional. El equipo de Easyrentestate es un grupo de profesionales comprometidos, cuya prioridad es la satisfacción y seguridad del inversor.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        <!----><!---->
    </div>
</div>

<app-public-footer></app-public-footer>
